import api from '../api/apiweb-factura.js';

// getstatusdte devuelve el estado del documento mientras el backend lo procesa.
// Sólo GENERADO es éxito; el resto de los estados terminales (por ejemplo cuando
// no quedan folios disponibles) hay que informarlos de inmediato en vez de
// seguir consultando hasta agotar los intentos, porque el documento nunca va a
// llegar a GENERADO y el usuario queda mirando un spinner sin explicación.
const ESTADOS_EN_PROCESO = [
  'PROCESANDO',
  'PENDIENTE',
  'EN_PROCESO',
  'ENPROCESO',
  'RECIBIDO',
  'INGRESADO',
  'CREADO',
];

// Cortamos también cuando el servicio de estado falla varias veces seguidas
// (500 o caída de red): reintentar 3 minutos no lo va a arreglar.
const MAX_ERRORES_SEGUIDOS = 3;

const normalizar = (estado) => (estado == null ? '' : String(estado).trim().toUpperCase());

// Sin estado en la respuesta asumimos que el documento aún está en la cola.
const enProceso = (estado) => estado === '' || ESTADOS_EN_PROCESO.includes(estado);

const mensajeDeEstado = (data) =>
  data?.msg || data?.mensaje || data?.error || data?.detalle || data?.descripcion || null;

const erroresDeEstado = (data) =>
  Array.isArray(data?.errores) && data.errores.length > 0 ? data.errores : null;

const esperar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Consulta el estado del DTE hasta que termine de procesarse.
 *
 * Devuelve el objeto que se guarda en el estado del formulario:
 *  - { estado: 'GENERADO', data }
 *  - { estado: 'RECHAZADO', data: null, errores } cuando el backend detalla qué falló
 *  - { estado: 'ERROR', data: null, mensaje } para cualquier otro fallo terminal
 *  - { estado: 'TIMEOUT', data: null } si se agotaron los intentos sin resolución
 */
export const consultarEstadoDte = async (idDoc, { intervaloMs = 3000, maxIntentos = 60 } = {}) => {
  let erroresSeguidos = 0;

  for (let intento = 0; intento < maxIntentos; intento++) {
    try {
      const { data } = await api.estadoFactura(idDoc);
      erroresSeguidos = 0;

      const estado = normalizar(data?.estado);
      if (estado === 'GENERADO') return { estado: 'GENERADO', data };

      if (!enProceso(estado)) {
        const errores = erroresDeEstado(data);
        if (errores) return { estado: 'RECHAZADO', data: null, errores };
        return { estado: 'ERROR', data: null, mensaje: mensajeDeEstado(data) };
      }
    } catch (error) {
      // 400 = idDoc inválido: no tiene sentido seguir reintentando.
      if (error?.response?.status === 400) {
        return { estado: 'ERROR', data: null, mensaje: mensajeDeEstado(error?.response?.data) };
      }
      console.error('Error al consultar el estado del documento:', error);
      erroresSeguidos += 1;
      if (erroresSeguidos >= MAX_ERRORES_SEGUIDOS) {
        return {
          estado: 'ERROR',
          data: null,
          mensaje: 'No se pudo consultar el estado del documento.',
        };
      }
    }
    await esperar(intervaloMs);
  }

  return { estado: 'TIMEOUT', data: null };
};

export default consultarEstadoDte;
